import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import amplitude from 'amplitude-js';
import smartlookClient from 'smartlook-client';
import ScrollToTop from 'react-scroll-up';
import { withApollo } from '@apollo/client/react/hoc';
import { getCommitFileIssues } from '../../actions/api';
import * as types from '../../constants/ActionTypes';
import { getVcsIdBySlug, ISSUES_GROUP, VCS_FROM_SLUG, } from '../../constants/api';
import { IS_APP_CODEAC } from '../../constants/env';
import ErrorPageContent from '../../components/ErrorPageContent';
import Icon from '../../components/Icon';
import Setup from '../../components/Setup';
import Layout from '../../containers/Layout';
import { withQuickFixModal } from './components/QuickFixModal';
import { withQuickFixSuggestionsModal } from './components/QuickFixesSuggestionsModal';
import { withQuickFixesForPullRequestModal } from './components/QuickFixesForPullRequestModal';
import { HANDLED_ERRORS } from '../../constants/types';
import { withPlanInfo } from '../../components/hoc/WithPlanInfo';
import { handleBranchInUrl } from '../../utils/repositoryNameAndOwner';
import { clearBranchName, replaceAsciiCharWithSlash, replaceSlashWithAsciiChar } from '../../utils/resolveBranch';
import ApiV2ModelContext from '../../contexts/ApiV2ModelContext';
import DefectList from '../../model/entities/DefectList';
import CommitCodeCoverage from '../../model/entities/CommitCodeCoverage';
import { CommitDetail } from './components/CommitDetail';
import { getRepositoryFullnameFromMatch } from '../../utils/getRepository';
let NEW_ISSUES_FILTER_ENABLED = IS_APP_CODEAC;
export const urlContainsGroup = (pathname) => {
    return Object.values(ISSUES_GROUP).find(issue => new RegExp(`/${issue}$|/${issue}/`).test(pathname));
};
export class CommitPage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loading: false,
            loadTimeout: null,
            notFound: false,
            pullRequest: null,
            commit: {},
            rawReports: [],
            files: {},
            fileIds: {},
            commitIssues: [],
            tools: {},
            filteredRules: [],
            generatedFiles: [],
            newIssuesCount: 0,
            filterByNewIssues: NEW_ISSUES_FILTER_ENABLED,
            filteredFiles: {},
            hiddenType: '',
            showErrorMessage: false,
            commitCodeCoverage: {},
            defectList: new DefectList([], 0),
            issuesLimit: 10,
        };
        this.getCommitHash = () => {
            const { match, pullRequestId } = this.props;
            const { pullRequest } = this.state;
            // @ts-expect-error TS2339: Property sourceCommit does not exist on type never
            return pullRequestId && pullRequest ? pullRequest?.sourceCommit.hash : match.params.hash;
        };
        this.loadPullRequestDetail = async () => {
            const { match, pullRequestId, repository } = this.props;
            const repositoryNameFromUrl = match.url.substring(match.url.indexOf(match.params.vcs) + match.params.vcs.length + 1, match.url.indexOf('/pull-requests'));
            let repositoryData = repository;
            if (!repository) {
                repositoryData = await this.fetchDashboardQuery(repositoryNameFromUrl, true);
            }
            else {
                repositoryData = repository;
            }
            if (repositoryData) {
                try {
                    const pullRequestDetailResponse = await this.context.getPullRequestDetail(repositoryData.id, pullRequestId);
                    if (pullRequestDetailResponse) {
                        this.setState({
                            pullRequest: pullRequestDetailResponse,
                            loading: false,
                        }, () => this.loadQueries(false, false));
                    }
                }
                catch (error) {
                    const statusCode = error.networkError?.statusCode;
                    if (HANDLED_ERRORS.includes(statusCode)) {
                        this.setState({
                            notFound: true,
                            loading: false,
                        });
                    }
                    else {
                        throw error;
                    }
                }
            }
        };
        this.generateFilesFromReports = (reports, rawReports) => {
            const files = {};
            for (const report of reports) {
                if (!files[report.filePath]) {
                    files[report.filePath] = {
                        errorCount: 0,
                        filePath: report.filePath,
                        ids: [],
                        messages: [],
                        source: report.source,
                        warningCount: 0,
                    };
                }
                else {
                    const source1 = files[report.filePath].source?.split('\n'), source2 = report.source?.split('\n');
                    files[report.filePath].source = source1?.map((line, index) => line || source2[index]).join('\n');
                }
                files[report.filePath].errorCount += report.errorCount;
                files[report.filePath].ids.push(report.id);
                files[report.filePath].messages.push(...report.messages);
                files[report.filePath].warningCount += report.warningCount;
                files[report.filePath].truncated = report.truncated;
                files[report.filePath].fixes = report.fixes;
                files[report.filePath].showTruncated =
                    report.messages.length !== files[report.filePath].errorCount + files[report.filePath].warningCount;
            }
            Object.keys(files).forEach((filePath) => (files[filePath].messages = files[filePath].messages.sort((first, second) => first.line - second.line)));
            const missingFiles = this.generateMissingFiles(files);
            const generatedFiles = this.produceGeneratedFiles(rawReports);
            return { files, missingFiles, generatedFiles };
        };
        this.produceGeneratedFiles = (rawReports) => {
            const { t } = this.props;
            const generatedFilesReports = rawReports.filter((report) => report.tool === t('siteName').toLowerCase());
            let generatedFiles = [];
            for (const report of generatedFilesReports) {
                if (!report.issues) {
                    continue;
                }
                for (const issue of report.issues) {
                    if (issue.ruleId === 'GeneratedFiles') {
                        generatedFiles = issue.options?.files ?? issue.options;
                    }
                }
            }
            return generatedFiles;
        };
        this.generateMissingFiles = (files) => {
            const missingFiles = [];
            const sortedFiles = Object.keys(files).sort((first, second) => first.localeCompare(second));
            for (const filePath of sortedFiles) {
                if (files[filePath].messages.length === 0) {
                    missingFiles.push(filePath);
                }
                else {
                    break;
                }
            }
            return missingFiles;
        };
        this.applyFilters = () => {
            const { match, location } = this.props;
            const { tools } = this.state;
            const filterFirst = (match.params.filterFirst || '').replace('%2F', '/');
            const filterSecond = (match.params.filterSecond || '').replace('%2F', '/');
            const groupType = urlContainsGroup(location.pathname);
            const filter = (filterFirst !== groupType ? filterFirst : filterSecond).replace('%2F', '/');
            const filterRules = () => {
                return Object.keys(tools).map((key) => {
                    // @ts-expect-error TS7053: Element implicitly has an any type because expression of type string can't be used to index type {}
                    if (Object.keys(tools[key]).filter((rule) => filter === rule).length) {
                        this.handleFilterRule(key, filter);
                    }
                });
            };
            if (groupType) {
                this.handleFilterType(filterFirst, false);
                if (filterSecond) {
                    filterRules();
                }
            }
            else if (filter && Object.keys(tools).length) {
                filterRules();
            }
            return filter;
        };
        this.setFilterByNewIssues = (filterByUrl, files) => {
            const { filterByNewIssues } = this.state;
            const { match } = this.props;
            const filter = this.applyFilters();
            const newFiles = Object.values(files).map((file) => file.messages.filter((message) => message.new === true));
            const formattedNewFiles = newFiles.flat().map((message) => message.tool + '#' + message.ruleId);
            const newFilesRules = formattedNewFiles.filter((file, index, newFilesArray) => newFilesArray.indexOf(file) === index);
            const newFileIsSelected = !!newFilesRules.find(rule => rule.includes(match.params.filterFirst ?? ''));
            if (filterByUrl && !newFileIsSelected && filter && filterByNewIssues) {
                return this.setState({
                    filterByNewIssues: false,
                }, this.loadQueries);
            }
        };
        this.handleLoadFile = (filePath) => {
            this.setState((prevState) => ({
                files: {
                    ...prevState.files,
                    [filePath]: {
                        ...(prevState.files[filePath] || {
                            errorCount: Object.keys(prevState.fileIds[filePath] || {}).reduce(
                            // @ts-expect-error TS7053: Element implicitly has an any type because expression of type string can't be used to index type
                            (acc, fileId) => acc + prevState.fileIds[filePath][fileId].errorCount, 0),
                            filePath: filePath,
                            ids: Object.keys(prevState.fileIds[filePath] || {}),
                            messages: [],
                            source: '',
                            warningCount: Object.keys(prevState.fileIds[filePath] || {}).reduce(
                            // @ts-expect-error TS7053: Element implicitly has an any type because expression of type string can't be used to index type
                            (acc, fileId) => acc + prevState.fileIds[filePath][fileId].warningCount, 0),
                        }),
                        loadingMessages: true,
                    },
                },
            }));
            // TODO: graphql replacement for commitFileIssues
            const { files: stateFiles, filterByNewIssues, fileIds } = this.state;
            const { match, dispatch } = this.props;
            return new Promise((resolve, reject) => {
                // @ts-expect-error TS7053: Element implicitly has an any type because expression of type string can't be used to index type
                const ids = stateFiles[filePath] ? stateFiles[filePath].ids : Object.keys(fileIds[filePath]);
                for (const fileId of ids) {
                    const onlyNew = NEW_ISSUES_FILTER_ENABLED && filterByNewIssues;
                    const commitFileIssuesAction = getCommitFileIssues(Number(fileId), this.getCommitHash(), VCS_FROM_SLUG[match.params.vcs], onlyNew);
                    dispatch(commitFileIssuesAction).then((action) => {
                        if (action.type === types.GET_COMMIT_FILE_ISSUES_SUCCESS) {
                            this.setState((prevState) => {
                                const files = { ...prevState.files };
                                files[filePath] = {
                                    ...files[filePath],
                                    messages: files[filePath] ? files[filePath].messages || [] : [],
                                    source: files[filePath] ? files[filePath].source || '' : '',
                                };
                                files[filePath].loadingMessages = false;
                                files[filePath].messages.push(...action.response.data.messages);
                                files[filePath].showTruncated =
                                    action.response.data.messages.length !==
                                        prevState.files[filePath].errorCount + prevState.files[filePath].warningCount;
                                const source1 = files[filePath].source.split('\n'), source2 = action.response.data.source.split('\n');
                                files[filePath].source =
                                    files[filePath].source === ''
                                        ? action.response.data.source
                                        : source1.map((line, index) => line || source2[index]).join('\n');
                                Object.keys(files).forEach((path) => (files[path].messages = files[path].messages
                                    .filter((message, index, self) => index ===
                                    self.findIndex((t) => t.column === message.column &&
                                        t.line === message.line &&
                                        t.message === message.message))
                                    .sort((first, second) => first.line - second.line)));
                                return {
                                    files,
                                };
                            });
                            resolve();
                        }
                        else {
                            console.error(action);
                            reject();
                        }
                    });
                }
            });
        };
        this.replaceHistoryWithRuleUrl = (pathname, ruleName) => {
            const { history } = this.props;
            const matchedTool = this.checkMatchedTools(pathname);
            if (matchedTool.length) {
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(`${pathname.substring(0, pathname.lastIndexOf('/'))}/${ruleName ? replaceSlashWithAsciiChar(ruleName) : ''}`);
            }
            else if (!pathname.includes(replaceSlashWithAsciiChar(ruleName))) {
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(`${pathname}/${replaceSlashWithAsciiChar(ruleName)}`);
            }
        };
        this.handleFilterRule = (tool, ruleName, empty = false) => {
            const { location, history } = this.props;
            const { tools, filteredRules } = this.state;
            if (!Object.prototype.hasOwnProperty.call(tools, tool) ||
                // @ts-expect-error TS7053: Element implicitly has an any type because expression of type string can't be used to index type {}
                !Object.prototype.hasOwnProperty.call(tools[tool], ruleName)) {
                return;
            }
            const rule = tool + '#' + ruleName;
            // @ts-expect-error TS2345: Argument of type string is not assignable to parameter of type never
            const isEmpty = filteredRules.includes(rule);
            const pathname = location.pathname;
            if (isEmpty || empty) {
                if (!empty) {
                    // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                    history.replace(pathname.substring(0, pathname.lastIndexOf('/')));
                }
                // @ts-expect-error TS2345: Argument of type is not assignable
                return this.setState((prevState) => ({
                    files: Object.assign({}, ...Object.keys(prevState.files).map((filePath) => ({
                        [filePath]: {
                            ...prevState.files[filePath],
                            loadingMessages: true,
                        },
                    }))),
                    filteredRules: prevState.filteredRules.filter((filteredRule) => filteredRule !== rule),
                    filteredFiles: [],
                }));
            }
            this.replaceHistoryWithRuleUrl(pathname, ruleName);
            this.setStateForFilteredFiles(isEmpty ? '' : rule);
        };
        this.filterFilesByType = (type) => {
            const { hiddenType, files } = this.state;
            const filteredFiles = {};
            // @ts-expect-error TS2769: No overload matches this call.
            Object.values(files).filter((file) => {
                if ((type === ISSUES_GROUP.ERRORS && file.errorCount !== 0) ||
                    (type === ISSUES_GROUP.WARNINGS && file.warningCount !== 0)) {
                    return (filteredFiles[file.filePath] = file);
                }
            });
            this.setState({ hiddenType: this.resolveType(hiddenType, type) });
            return filteredFiles;
        };
        this.setStateForFilteredFiles = (rule, filteredFiles) => {
            const filtered = filteredFiles && Object.keys(filteredFiles).length ? filteredFiles : this.state.filteredFiles;
            if (Object.keys(filtered).length || rule) {
                this.setState({
                    filteredFiles: filtered,
                    filteredRules: rule ? [rule] : [],
                }, () => {
                    const maxFiles = 10, filesFiltered = this.filterFiles(), filePaths = Object.keys(filesFiltered), load = (index) => {
                        if (!filesFiltered[filePaths[index]] ||
                            filesFiltered[filePaths[index]].messages.length > 0) {
                            return;
                        }
                        this.handleLoadFile(filePaths[index]).then(() => ++index >= maxFiles ? null : load(index));
                    };
                    load(0);
                });
            }
            else {
                const { location } = this.props;
                const pathname = location.pathname;
                const groupInUrl = urlContainsGroup(pathname);
                this.setState({
                    filteredFiles: {},
                    filteredRules: [],
                    hiddenType: groupInUrl ? groupInUrl : '',
                });
            }
        };
        this.handleFilterType = (type, deselect = false) => {
            const { location, history } = this.props;
            const pathname = location.pathname;
            const groupInUrl = urlContainsGroup(pathname);
            const filteredFiles = this.filterFilesByType(type);
            const endOfUrl = pathname.substring(pathname.lastIndexOf('/') + 1);
            const matchedTool = this.checkMatchedTools(pathname);
            if (deselect) {
                if (matchedTool && groupInUrl) {
                    this.handleFilterRule('', '', true);
                    // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                    history.replace(pathname.substring(0, pathname.indexOf(groupInUrl) - 1));
                }
                else if (groupInUrl === type) {
                    // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                    history.replace(pathname.substring(0, pathname.lastIndexOf('/')));
                }
                return this.setStateForFilteredFiles();
            }
            if (type === ISSUES_GROUP.ALL) {
                if (groupInUrl && matchedTool.length) {
                    // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                    history.replace(pathname.substring(0, pathname.indexOf(groupInUrl) - 1));
                }
                else if (groupInUrl || (matchedTool.length && !!groupInUrl)) {
                    // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                    history.replace(pathname.substring(0, pathname.lastIndexOf('/')));
                }
                return this.setStateForFilteredFiles();
            }
            else if (matchedTool && groupInUrl === type && endOfUrl !== type) {
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(`${pathname.substring(0, pathname.indexOf(matchedTool) - 1)}`);
            }
            else if (matchedTool && !groupInUrl) {
                this.handleFilterRule('', '', true);
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(`${pathname.substring(0, pathname.indexOf(matchedTool) - 1)}/${type}`);
            }
            else if (!groupInUrl) {
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(`${pathname}/${type}`);
            }
            else if (matchedTool && groupInUrl && groupInUrl !== type) {
                this.handleFilterRule('', '', true);
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(`${pathname.substring(0, pathname.indexOf(groupInUrl) - 1)}/${type}`);
            }
            else if (groupInUrl !== type || matchedTool === endOfUrl) {
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(`${pathname.substring(0, pathname.lastIndexOf('/'))}/${type}`);
            }
            this.setStateForFilteredFiles(type, filteredFiles);
        };
        this.checkMatchedTools = (pathname) => {
            const { tools } = this.state;
            const endOfUrl = pathname.substring(pathname.lastIndexOf('/') + 1);
            let matchedTool = '';
            Object.keys(tools).map((key) => {
                // @ts-expect-error TS7053: Element implicitly has an any type because expression of type string can't be used to index type {}
                const filteredRule = Object.keys(tools[key]).find((rule) => endOfUrl.indexOf(replaceSlashWithAsciiChar(rule)) !== -1);
                if (filteredRule && filteredRule.length !== 0 && endOfUrl === replaceSlashWithAsciiChar(filteredRule)) {
                    matchedTool = replaceSlashWithAsciiChar(filteredRule);
                }
            });
            return matchedTool;
        };
        this.handleToggleFilterByNewIssues = () => {
            const { filterByNewIssues, commit, filteredRules } = this.state;
            const { match, location, history } = this.props;
            const eventName = 'new-issues-filter';
            const eventProperties = {
                all: filterByNewIssues,
                commitHash: commit.hash,
                commitId: commit.id,
                repositoryFullname: `${match.params.owner}/${match.params.repository}`.replace('%2F', '/'),
            };
            amplitude.getInstance().logEvent(eventName, eventProperties);
            smartlookClient.track(eventName, eventProperties);
            if (filteredRules.length) {
                const pathname = location.pathname;
                // @ts-expect-error TS2339: Property 'replace' does not exist on type 'History'.
                history.replace(pathname.substring(0, pathname.lastIndexOf('/')));
            }
            return this.setState((prevState) => ({
                filterByNewIssues: !prevState.filterByNewIssues,
                files: {},
                filteredRules: [],
                filteredFiles: {},
                hiddenType: '',
                commit: prevState.commit,
            }), () => this.loadCommitDetail(!filterByNewIssues));
        };
        this.filterFiles = () => {
            const { fileIds, filteredRules, tools, filteredFiles, files } = this.state;
            // @ts-expect-error TS2339: Property 'length' does not exist on type 'never'.
            const filesForFilter = filteredFiles.length ? filteredFiles : files;
            const newFiles = {};
            if (!filteredRules.length) {
                return filesForFilter;
            }
            for (const rule of filteredRules) {
                // @ts-expect-error TS2339: Property 'indexOf' does not exist on type 'never'.
                if (rule.indexOf('#') !== -1) {
                    // @ts-expect-error TS2339: Property 'split' does not exist on type 'never'.
                    const tool = rule.split('#')[0];
                    // @ts-expect-error TS2339: Property 'split' does not exist on type 'never'.
                    const ruleId = rule.split('#')[1];
                    // @ts-expect-error TS7053: Element implicitly has an any type because expression of type any can't be used to index type {}
                    for (const filePath of (tools[tool] || {})[ruleId] || []) {
                        // @ts-expect-error TS7053: Element implicitly has an any type because expression of type any can't be used to index type {}
                        if (!filesForFilter[filePath] || !filesForFilter[filePath].messages) {
                            // @ts-expect-error TS2339: Property 'find' does not exist on type '{}'.
                            const selectedFileId = fileIds.find((fileId) => fileId.path === filePath);
                            newFiles[filePath] = {
                                filePath: filePath,
                                source: '',
                                messages: [],
                                ids: [selectedFileId.fileId],
                                errorCount: selectedFileId.errorCount,
                                warningCount: selectedFileId.warningCount,
                            };
                        }
                        else {
                            newFiles[filePath] = {
                                // @ts-expect-error TS7053: Element implicitly has an any type because expression of type any can't be used to index type {}
                                ...filesForFilter[filePath],
                                // @ts-expect-error TS7053: Element implicitly has an any type because expression of type any can't be used to index type {}
                                messages: filesForFilter[filePath].messages.filter((message) => message.ruleId === ruleId),
                            };
                        }
                    }
                }
                else {
                    // @ts-expect-error TS2769: No overload matches this call.
                    Object.values(filesForFilter).filter((file) => {
                        if (rule === ISSUES_GROUP.ERRORS) {
                            if (file.errorCount !== 0) {
                                newFiles[file.filePath] = file;
                            }
                        }
                        else {
                            if (file.warningCount !== 0) {
                                newFiles[file.filePath] = file;
                            }
                        }
                    });
                }
            }
            return newFiles;
        };
        this.handleScrollUp = () => {
            const eventName = 'scroll-up';
            amplitude.getInstance().logEvent(eventName);
        };
        this.getNames = () => {
            const { match, pullRequestId, repository, t } = this.props;
            const fullName = repository ? repository.getFullName() : getRepositoryFullnameFromMatch(match);
            const hash = match.params.hash ? match.params.hash.substr(0, 8) : '';
            if (!repository) {
                return {
                    fullName,
                    prTitle: '',
                    titlePrimary: '',
                    titleSecondary: '',
                };
            }
            const { titlePrimary, titleSecondary } = repository.getTitleParts();
            const prTitle = pullRequestId
                ? t('pullRequest') + ' #' + match.params.id + ' - ' + titlePrimary
                : titlePrimary + ' - ' + hash;
            return {
                fullName,
                prTitle,
                titlePrimary,
                titleSecondary,
            };
        };
        this.loadQueries = async (setNewIssues = false, filterByUrl = true) => {
            const { commit, filterByNewIssues } = this.state;
            const { owner, repository } = this.props.match.params;
            this.fetchDashboardQuery(`${owner}/${repository}`);
            try {
                await this.fetchCommitDetailQuery(!filterByNewIssues, setNewIssues, filterByUrl);
            }
            catch (error) {
                const statusCode = error.networkError?.statusCode;
                if ([400, 403, 404].includes(statusCode)) {
                    this.setState({
                        notFound: true,
                        loading: false,
                    });
                }
                else if (!Object.keys(commit).length || [500, 501, 502].includes(statusCode)) {
                    this.setState({
                        showErrorMessage: true,
                        loading: false,
                    });
                }
                else {
                    throw error;
                }
            }
        };
        this.fetchDashboardQuery = async (repositoryName, isPr = false) => {
            const { match, history, repository, dispatch } = this.props;
            const { branch, vcs: matchVcs } = match.params;
            const cleanFullname = repositoryName.includes('/b-')
                ? repositoryName.substring(0, repositoryName.indexOf('/b-'))
                : repositoryName;
            if (!repository) {
                const vcs = getVcsIdBySlug(matchVcs);
                const branchName = replaceAsciiCharWithSlash(clearBranchName(branch));
                try {
                    const dashboardResponse = await this.context.getDashboard(vcs, replaceAsciiCharWithSlash(cleanFullname), !isPr && branch && branchName);
                    if (dashboardResponse.repository) {
                        const repositoryData = dashboardResponse.repository;
                        const fullname = repositoryData.getFullName();
                        // @ts-expect-error TS2345: Argument of type History is not assignable to parameter of type History<unknown>
                        handleBranchInUrl(history, match, fullname, repositoryData.slug);
                        const activeBranch = match.params.branch ? repositoryData.getBranchByName(match.params.branch) : repositoryData.getMainBranch();
                        await dispatch({
                            type: types.ADD_REPOSITORY,
                            payload: dashboardResponse,
                        });
                        await dispatch({
                            type: types.UPDATE_ACTIVE_BRANCH,
                            payload: { repositoryId: repositoryData.id, activeBranch },
                        });
                        return dashboardResponse.repository;
                    }
                    else {
                        this.setState({ notFound: true, loading: false });
                        return null;
                    }
                }
                catch (error) {
                    const statusCode = error.networkError?.statusCode;
                    if (HANDLED_ERRORS.includes(statusCode)) {
                        this.setState({
                            notFound: true,
                            loading: false,
                        });
                    }
                    else {
                        throw error;
                    }
                }
            }
            return null;
        };
        this.fetchCommitDetailQuery = async (showAll = false, setNewIssues = false, filterByUrl = true) => {
            const { issuesLimit, filterByNewIssues, hiddenType } = this.state;
            const { user, match, t } = this.props;
            const commitHash = this.getCommitHash();
            const onlyNew = NEW_ISSUES_FILTER_ENABLED && setNewIssues && filterByNewIssues;
            try {
                const commitDetailAllDataResponse = await this.context.getCommitDetailAllData(commitHash, getVcsIdBySlug(match.params.vcs), !showAll && onlyNew, issuesLimit, hiddenType && this.resolveType(hiddenType));
                const commitDetailReports = commitDetailAllDataResponse?.commitDetail.reports;
                const defects = commitDetailAllDataResponse?.defectList.defects;
                if (onlyNew && (!commitDetailReports.length || !defects.length)) {
                    await this.fetchCommitDetailQuery(true);
                }
                else if (commitDetailAllDataResponse) {
                    const { commitCodeCoverage, commitDetail, defectList } = commitDetailAllDataResponse;
                    const { rawReports, reports, newIssuesCount, fileIds, tools } = commitDetail;
                    const { commit } = commitDetail;
                    const { files, generatedFiles } = this.generateFilesFromReports(reports, rawReports);
                    if (IS_APP_CODEAC) {
                        this.setCommitCodeCoverage(commitCodeCoverage);
                    }
                    this.setState({
                        loading: false,
                        // @ts-expect-error TS2322: Type Timeout | null is not assignable to type number | null
                        loadTimeout: commit.isDone() || commit.isTimedOut() ? null : setTimeout(() => this.loadCommitDetail(setNewIssues), 3000),
                        commit,
                        rawReports,
                        files,
                        fileIds,
                        commitIssues: rawReports.filter(({ tool }) => tool === t('siteName').toLowerCase()),
                        tools: this.formatTools(tools),
                        filteredRules: [],
                        generatedFiles: generatedFiles || [],
                        newIssuesCount,
                        defectList,
                        filterByNewIssues: !showAll,
                    });
                    if (setNewIssues) {
                        this.setFilterByNewIssues(filterByUrl, files);
                    }
                    else {
                        this.applyFilters();
                    }
                }
            }
            catch (error) {
                const statusCode = error.networkError?.statusCode;
                if (HANDLED_ERRORS.includes(statusCode)) {
                    this.setState({
                        notFound: true,
                        loading: false,
                    });
                }
                else {
                    throw error;
                }
            }
        };
        this.setCommitCodeCoverage = async (commitCodeCoverage) => {
            if (commitCodeCoverage) {
                const codeCoverage = {
                    digest: commitCodeCoverage.digest,
                    ...(commitCodeCoverage.digestDiff && { digestDiff: commitCodeCoverage.digestDiff }),
                    files: Object.assign({}, ...commitCodeCoverage.entries.map(({ lines, sourceFile }) => ({
                        [sourceFile]: Object.assign({}, ...lines.map(({ executionCount, number }) => ({ [number]: executionCount }))),
                    }))),
                };
                this.setState({ commitCodeCoverage: new CommitCodeCoverage(codeCoverage) });
            }
        };
        this.formatTools = (tools) => {
            const issueResolver = (issues) => {
                let formattedIssues = {};
                issues.forEach((issue) => (formattedIssues = { ...formattedIssues, [issue.name]: issue.fileNames }));
                return formattedIssues;
            };
            let formattedTools = {};
            tools.forEach((tool) => (formattedTools = {
                ...formattedTools,
                [tool.name]: issueResolver(tool.issues),
            }));
            return formattedTools;
        };
        this.renderLayout = () => {
            const { proPlan, match, repository, user, onShowDiffClick } = this.props;
            const { hiddenType, commit, pullRequest, commitCodeCoverage, loading, generatedFiles, rawReports, showErrorMessage, newIssuesCount, filterByNewIssues, commitIssues, defectList, files, filteredRules, filteredFiles, } = this.state;
            const isRepositoryPrivate = !!repository?.private;
            const isLoginRequired = repository && 'private' in repository ? isRepositoryPrivate : false;
            const showClearFilterButton = !!(newIssuesCount &&
                filterByNewIssues &&
                !(newIssuesCount === commit.errorCount + commit.warningCount));
            const reportsFiles = this.filterFiles();
            const { fullName, prTitle, titlePrimary, titleSecondary } = this.getNames();
            return (_jsxs(Layout, { loginRequired: isLoginRequired, withDrawer: true, title: prTitle, loading: loading, match: match, titlePrimary: titlePrimary, titleSecondary: titleSecondary, repository: repository, children: [_jsx("div", { className: "container repository-detail__container", children: !loading && _jsx(CommitDetail, { user: user, repository: repository, fullName: fullName, titlePrimary: titlePrimary, titleSecondary: titleSecondary, generatedFiles: generatedFiles, rawReports: rawReports, showErrorMessage: showErrorMessage, match: match, loading: loading, proPlan: proPlan, commit: commit, pullRequest: pullRequest ?? undefined, commitCodeCoverage: commitCodeCoverage ?? undefined, commitIssues: commitIssues, reportsFiles: reportsFiles, showClearFilterButton: showClearFilterButton, hiddenType: hiddenType, onHandleLoadFile: this.handleLoadFile, onHandleToggleFilterByNewIssues: this.handleToggleFilterByNewIssues, defectList: defectList, filterByNewIssues: filterByNewIssues, onHandleFilterRule: this.handleFilterRule, onHandleFilterType: this.handleFilterType, newIssuesCount: newIssuesCount, files: files, filteredRules: filteredRules, filteredFiles: filteredFiles, isNewFilterIssuesEnabled: NEW_ISSUES_FILTER_ENABLED, onShowDiffClick: onShowDiffClick }) }), isRepositoryPrivate && _jsx(Setup, { loading: loading }), _jsx(ScrollToTop, { showUnder: 160, style: { zIndex: 10 }, children: _jsx(Icon, { name: "up", className: "scroll-up", onClick: this.handleScrollUp }) })] }));
        };
    }
    componentWillUnmount() {
        if (this.state.loadTimeout) {
            clearTimeout(this.state.loadTimeout);
        }
    }
    decideWhetherToLoadCommitDetail(props) {
        const { commit, pullRequest, loading } = this.state;
        NEW_ISSUES_FILTER_ENABLED = !props.pullRequestId && IS_APP_CODEAC;
        if (props.match.params.hash !== ('hash' in commit && commit.hash) && !props.pullRequestId) {
            this.setState({
                loading: true,
                files: {},
                fileIds: {},
            }, () => this.loadQueries(true));
        }
        else if (props.pullRequestId &&
            // @ts-expect-error TS2339: Property 'prId' does not exist on type 'never'.
            (!pullRequest || pullRequest.prId !== props.pullRequestId) &&
            !loading) {
            this.setState({
                loading: true,
            }, () => this.loadPullRequestDetail());
        }
        if (!props.repository) {
            this.setState({ loading: true });
        }
        this.setState({ filteredFiles: this.filterFiles() });
    }
    componentDidMount() {
        this.decideWhetherToLoadCommitDetail(this.props);
    }
    async loadCommitDetail(setNewIssues = false, filterByUrl = true) {
        const { loading } = this.state;
        if (!loading) {
            await this.loadQueries(setNewIssues, filterByUrl);
        }
    }
    resolveType(hiddenType, type) {
        if (!hiddenType || !type) {
            return '';
        }
        const typeToHide = type ? type : hiddenType;
        return typeToHide === ISSUES_GROUP.ERRORS ? ISSUES_GROUP.WARNINGS : ISSUES_GROUP.ERRORS;
    }
    render() {
        const { location } = this.props;
        const { notFound, hiddenType, loading } = this.state;
        if (!loading && notFound) {
            return _jsx(ErrorPageContent, { ...this.props, code: 404 });
        }
        const groupType = urlContainsGroup(location.pathname);
        if (hiddenType && !groupType) {
            this.setState({ hiddenType: '' });
        }
        else if (!hiddenType && groupType) {
            this.setState({
                hiddenType: groupType === ISSUES_GROUP.ERRORS ? ISSUES_GROUP.WARNINGS : ISSUES_GROUP.ERRORS,
            });
        }
        return this.renderLayout();
    }
}
CommitPage.contextType = ApiV2ModelContext;
const mapStateToProps = (state) => ({
    repositories: state.repositories,
    user: state.user,
    repository: state.repository.repository,
    activeBranches: state.activeBranches,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default withQuickFixSuggestionsModal(withQuickFixesForPullRequestModal(
// @ts-expect-error TS2345: Argument of type typeof CommitPage is not assignable to parameter of type
withQuickFixModal(withPlanInfo(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withApollo(CommitPage)))))));
